import React, { useEffect, useState, useCallback } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton,
    Dialog, DialogTitle, DialogContent, Grid, TextField, DialogActions, FormControl, InputLabel, Select,
    MenuItem, DialogContentText
} from '@mui/material';
import InputMask from 'react-input-mask';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../services/api';


const Turmas = () => {
    const [registros, setRegistros] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [registroAtual, setRegistroAtual] = useState({ descricao: '', ativo: 'S', prazo: '' });
    const [isEditMode, setIsEditMode] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [ativoFilter, setAtivoFilter] = useState('S');

    const handleFilterChange = useCallback(() => {
        // Construir o objeto de filtros com os valores atuais
        const ativoValue = ativoFilter === "Todos" ? "" : ativoFilter;
        const filters = {
            ativo: ativoValue,
        };
        // Fazer uma nova requisição ao backend com os filtros aplicados
        fetchRegistros(filters);
    }, [ativoFilter]);

    useEffect(() => {
        handleFilterChange();
    }, [handleFilterChange]);


    const fetchRegistros = async (filters = {}) => {
        try {
            const response = await api.get(`/turmas/list`, { params: filters });
            setRegistros(response.data);
        } catch (error) {
            console.error('Erro ao buscar turmas', error);
        }
    };

    const handleAddClick = () => {
        setRegistroAtual({ descricao: '' });
        setIsEditMode(false);
        setOpenEditDialog(true);
    };

    // Abrir modal para editar
    const handleEditClick = (r) => {
        setRegistroAtual(r);
        setIsEditMode(true);
        setOpenEditDialog(true);
    };

    // Função para deletar
    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setOpenDialog(true); // Abre o diálogo de confirmação
    };

    // Confirmar exclusão
    const handleConfirmDelete = async () => {
        try {
            await api.delete(`/turmas/${deleteId}`);
            fetchRegistros();
            setRegistros(registros.filter(r => r.id !== deleteId));
            setOpenDialog(false);
            setDeleteId(null);
        } catch (error) {
            console.error('Erro ao excluir ', error);
        }
    };

    // Cancelar exclusão
    const handleCancelDelete = () => {
        setOpenDialog(false);
        setDeleteId(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRegistroAtual({ ...registroAtual, [name]: value });
    };

    // Salvar ou editar 
    const handleSaveRegistro = async () => {

        if (isEditMode) {
            try {
                await api.put(`/turmas/${registroAtual.id}`, registroAtual);
                fetchRegistros(); // Atualizar a lista
            } catch (error) {
                console.error('Erro ao atualizar registro', error);
            }
        } else {
            try {
                await api.post('/turmas', registroAtual);
                fetchRegistros(); // Atualizar a lista
            } catch (error) {
                console.error('Erro ao criar registro', error);
            }
        }

        setOpenEditDialog(false);
        setRegistroAtual({ descricao: '', ativo: 'S', prazo: '' });
    };



    return (
        <div style={{ marginTop: 80 }}>

            <TableContainer component={Paper} sx={{ maxWidth: '80%', margin: 'auto' }}>

                <Grid container alignItems="center" justifyContent="space-between" sx={{ marginTop: 2}}>
                    {/* Botão INCLUIR alinhado à esquerda */}
                    <Grid item>
                        <Button variant="contained"
                            onClick={handleAddClick}
                            sx={{ width: 80, marginBottom: 2, marginTop:2, backgroundColor: 'red', color: 'white', '&:hover': { backgroundColor: 'darkred' } }}>
                            INCLUIR
                        </Button>
                    </Grid>

                    {/* Filtro e botão de aplicar filtros alinhados à direita */}
                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                            
                                <FormControl sx={{ minWidth: 150 }} fullWidth>
                                <InputLabel id="ativo-label" sx={{ fontSize: '1rem', color: 'black'}}>Ativo?</InputLabel>
                                    <Select
                                        labelId="ativo-label"
                                        value={ativoFilter}
                                        onChange={(e) => setAtivoFilter(e.target.value)}
                                        label="Ativo?"
                                    >
                                        <MenuItem value="N">Não</MenuItem>
                                        <MenuItem value="S">Sim</MenuItem>
                                        <MenuItem value="Todos">Todos</MenuItem>
                                    </Select>
                                    
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary" onClick={handleFilterChange}>
                                    APLICAR FILTROS
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


                <Table>
                    <TableHead sx={{ backgroundColor: 'red' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white' }}>ID</TableCell>
                            <TableCell sx={{ color: 'white' }}>Descrição</TableCell>
                            <TableCell sx={{ color: 'white' }}>Prazo de Inscrição</TableCell>
                            <TableCell sx={{ color: 'white' }}>Ativo</TableCell>
                            <TableCell sx={{ color: 'white' }}>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {registros.map((r) => (
                            <TableRow key={r.id} >
                                <TableCell>{r.id}</TableCell>
                                <TableCell>{r.descricao}</TableCell>
                                <TableCell>{r.prazo}</TableCell>
                                <TableCell>{r.ativo}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEditClick(r)}><EditIcon /></IconButton>
                                    <IconButton onClick={() => handleDeleteClick(r.id)}><DeleteIcon /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            {/* Diálogo de confirmação de exclusão */}
            <Dialog open={openDialog} onClose={handleCancelDelete}>
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    <DialogContentText>Você tem certeza que deseja excluir este registro?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancelar</Button>
                    <Button onClick={handleConfirmDelete} color="secondary">Excluir</Button>
                </DialogActions>
            </Dialog>


            {/* Diálogo de inclusão/edição */}
            <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
                <DialogTitle>{isEditMode ? 'Editar ' : 'Novo '}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <TextField
                                label="Descricao"
                                name="descricao"
                                value={registroAtual.descricao}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <InputMask
                                mask="99/99/9999"
                                value={registroAtual.prazo}
                                onChange={handleInputChange}
                            >
                                {() => (
                                    <TextField
                                        label="Prazo de Inscricao"
                                        name="prazo"
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                )}
                            </InputMask>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="ativo-label">Ativo</InputLabel>
                                <Select
                                    labelId="ativo-label"
                                    name="ativo"
                                    value={registroAtual.ativo}
                                    onChange={handleInputChange}
                                    label="Ativo"
                                >
                                    <MenuItem value="S">Sim</MenuItem>
                                    <MenuItem value="N">Não</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancelar</Button>
                    <Button onClick={handleSaveRegistro} color="primary">Salvar</Button>
                </DialogActions>
            </Dialog>
        </div >
    )
}

export default Turmas;

